// extracted by mini-css-extract-plugin
export default {"mCard":"cB-z","image":"dB-z","imageNoBackground":"eB-z","imageHasCategory":"fB-z","fullWidth":"gB-z"};